var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBannerHerramientas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1639,
    height: 456.949,
    viewBox: "0 0 1639 456.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_167",
    "data-name": "Trazado 167",
    d: "M663.445,156.686V612.222h694.07A413.32,413.32,0,0,0,1338.2,156.686Z",
    transform: "translate(-663.445 -156.686)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_fondo_herramientas_sencillas",
    "data-name": "img_fondo herramientas sencillas",
    transform: "translate(-140 -969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "drone-pilot-photographer-prepares-launch-flight-2021-09-02-08-35-32-utc",
    d: "M0,0H1639V456.949H0Z",
    transform: "translate(140 969)",
    fill: "#048cc6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_77",
    "data-name": "Grupo 77",
    transform: "translate(140 969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_45",
    "data-name": "Rect\\xE1ngulo 45",
    width: 287.605,
    height: 455.772,
    transform: "translate(744.276 0.94)",
    fill: "#009269"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_46",
    "data-name": "Rect\\xE1ngulo 46",
    width: 753.024,
    height: 455.772,
    transform: "translate(0 1.177)",
    fill: "#009269"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    d: "M1184.188,384.571c0,125.858,103.859,227.885,231.974,227.885s231.974-102.027,231.974-227.885-103.859-227.885-231.974-227.885-231.974,102.027-231.974,227.885",
    transform: "translate(-384.282 -156.686)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72",
    transform: "translate(0 1.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_71",
    "data-name": "Grupo 71",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_48",
    "data-name": "Rect\\xE1ngulo 48",
    width: 1784.712,
    height: 522.963,
    transform: "translate(-1217.629 240.319)",
    fill: "#048cc6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_49",
    "data-name": "Rect\\xE1ngulo 49",
    width: 1784.712,
    height: 522.963,
    transform: "translate(-1217.63 -282.644)",
    fill: "#048cc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_165",
    "data-name": "Trazado 165",
    d: "M825.174,812.865h999.9l0-522.961H828.41c8.255,19.257,16.764,38.367,25.056,57.3,42.62,97.239,81.42,205.34,51.055,306.9-16.69,55.979-53.564,106.313-79.346,158.756",
    transform: "translate(-528.351 -49.592)",
    fill: "#82ab40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_166",
    "data-name": "Trazado 166",
    d: "M852.337,522.96h996.658V0H903.5c-33.019,92.991-94.366,178.19-105.2,276.288-9.38,84.738,20,167.079,54.039,246.673",
    transform: "translate(-552.278 -282.647)",
    fill: "#82ab40"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBannerHerramientas);
export default __webpack_public_path__ + "static/media/img_banner_herramientas.edbbfccc70c70a91800fd7f2c948e89e.svg";
export { ForwardRef as ReactComponent };